import {alertConstants} from '../_constants';
import { history } from '../_helpers';

export const alertActions = {
    success,
    error,
    clear
};


function success(response) {
    let message = response;

    //create sessionstorage to show alert after refresh 
    sessionStorage.setItem('alert' , message); 
    sessionStorage.setItem('type' , 'info'); 

    return { 
        type: alertConstants.SUCCESS, 
        message
    };
}

function error(response) {
    let message = response.body ? JSON.stringify(response.body) : response.text;
    
    //only show common errors 
    if(response.statusCode !== 402){

        //create sessionstorage to show alert after refresh 
        sessionStorage.setItem('alert' , message); 
        sessionStorage.setItem('type' , 'error'); 
    }

    return { 
        type: alertConstants.ERROR, 
        message 
    };
}

function clear() {
    return { 
        type: alertConstants.CLEAR 
    };
}



// WEBPACK FOOTER //
// ./src/_actions/alert.actions.js